// Styles for ProfileSectionHelper go here.
import { baseVariables, toRem } from '@marriott/mi-ui-library';
import { SkeletonLoaderDuration } from '../../../modules';
import styled from 'styled-components';

export const StyledProfileSectionElement = styled.div`
  .profile-sections-wrapper {
    .section-wrapper {
      border-radius: ${toRem(14)};
      background-color: ${baseVariables.color.base20};
    }
    .popover-container {
      display: inline-flex;
      position: relative;
    }

    .popover-card {
      display: none !important;
      position: absolute;
      top: ${toRem(38)};
      left: 100% !important;
      margin-left: ${toRem(8)};
      @media ${baseVariables.mediaQuery.md} {
        top: ${toRem(-23)};
        left: ${toRem(6)};
      }
    }
    .popover-wrapper:hover + .popover-card,
    .popover-card:hover {
      display: block !important;
      z-index: 1;
    }
  }
  .section-border {
    border-bottom: ${toRem(1)} solid ${baseVariables.color.neutral20};
  }

  .section-title {
    background-color: transparent;
  }

  .border-line {
    border-bottom: ${toRem(1)} solid ${baseVariables.color.neutral00};
    &:hover {
      font-weight: ${baseVariables.font.fontWeightRegular};
    }
  }

  .btn-editLink {
    background: transparent;
    :focus-visible {
      border: ${toRem(2)} solid ${baseVariables.color.base10};
    }
  }
  .member-number {
    color: ${baseVariables.color['neutral40']};
  }
  #remember-me + label {
    padding-left: ${toRem(18)};
  }
  .cardData {
    &__VS {
      width: ${toRem(44)};
      clip: rect(0 ${toRem(44)} ${toRem(28)} ${toRem(1)}) !important;
      top: -${toRem(2)} !important;
      position: absolute;
    }

    &__AX {
      width: ${toRem(32)};
      clip: rect(${toRem(24)} ${toRem(32)} ${toRem(52)} ${toRem(1)}) !important;
      top: -${toRem(24)} !important;
      position: absolute;
    }

    &__DC {
      width: ${toRem(40)};
      clip: rect(${toRem(64)} ${toRem(40)} ${toRem(92)} ${toRem(1)}) !important;
      top: -${toRem(64)} !important;
      position: absolute;
    }

    &__DS {
      width: ${toRem(44)} !important;
      clip: rect(${toRem(104)} ${toRem(44)} ${toRem(132)} ${toRem(1)}) !important;
      top: -${toRem(104)} !important;
      position: absolute;
    }

    &__JC {
      width: ${toRem(36)};
      clip: rect(${toRem(124)} ${toRem(36)} ${toRem(152)} ${toRem(1)}) !important;
      top: -${toRem(124)} !important;
      position: absolute;
    }

    &__MC {
      width: ${toRem(44)} !important;
      clip: rect(${toRem(189)} ${toRem(44)} ${toRem(217)} ${toRem(1)}) !important;
      top: -${toRem(189)} !important;
      position: absolute;
    }

    &__UP {
      width: ${toRem(44)};
      clip: rect(${toRem(230.08)} ${toRem(48)} ${toRem(258.08)} ${toRem(1)}) !important;
      top: -${toRem(230.08)} !important;
      position: absolute;
    }
    &__defaultLabel {
      color: ${baseVariables.color['alert30']};
    }
    &__expiryLabel {
      color: ${baseVariables.color['alert50']};
    }
    &__expiredIcon {
      color: ${baseVariables.color['alert50']};
    }
    &__image {
      width: ${toRem(40)};
      height: ${toRem(22)};
    }

    // Gift card specific styling
    &__giftCard {
      width: ${toRem(40)};
      height: ${toRem(22)};
      object-fit: contain;
    }

    &__giftCardRow {
      display: grid;
      grid-template-columns: repeat(1, 1fr);
      @media ${baseVariables.mediaQuery.md} {
        grid-template-columns: repeat(2, 1fr);
        gap: ${toRem(24)};
      }
    }

    &__cardpin {
      gap: ${toRem(8)};
      margin-bottom: ${toRem(16)};
      @media ${baseVariables.mediaQuery.md} {
        margin-bottom: 0;
      }
    }
  }
  .min-width-max-content {
    min-width: max-content;
  }

  // Badge overlay variants for gift card status
  .m-badge-overlay-neutral {
    background: var(--Colors-base-15, rgba(28, 28, 28, 0.2));
    color: var(--Colors-base-10, #1c1c1c);
    border-radius: 4px;
    padding: 0.5rem;
    width: fit-content;
    display: flex;
    align-items: center;
    font-size: 12px;
    font-style: normal;
    font-weight: 700;
    line-height: 100%; /* 12px */
    letter-spacing: 1.2px;
    text-transform: uppercase;
    leading-trim: both;
    text-edge: cap;
    font-feature-settings: 'liga' off, 'clig' off;
  }

  // Small separator for gift card balance/expiration
  .gift-card-separator {
    font-size: 0.75rem;
    line-height: 1;
  }

  // Gift card balance and expiry text styling
  .gift-card-balance,
  .gift-card-expiry {
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 150%; /* 21px */
    color: var(--Colors-neutral-40, #707070);
  }
  .image-wrapper {
    img {
      height: ${toRem(32)};
    }
  }
  .skeleton-style {
    width: 100%;
    &:after {
      animation-duration: ${SkeletonLoaderDuration};
    }

    &-header,
    &-line-item {
      height: ${toRem(24)};
    }
  }
  .item-gap {
    gap: ${toRem(32)};
  }

  .card-expiring-icon {
    color: ${baseVariables.color['alert40']};
    &:before {
      font-size: ${toRem(16)};
    }
  }

  .card-expired-icon {
    color: ${baseVariables.color['alert50']};
    &:before {
      font-size: ${toRem(16)};
    }
  }

  .card-expiring-label {
    color: ${baseVariables.color['alert40']};
  }
  .card-expired-label {
    color: ${baseVariables.color['alert50']};
  }

  .profile-section-element-v2 {
    .section-heading {
      background-color: ${baseVariables.color.base20};
      border-radius: 0;
      box-shadow: 0 ${toRem(2)} ${toRem(10)} 0 rgba(0, 0, 0, 0.07);
      position: relative;

      @media ${baseVariables.mediaQuery.lg} {
        border-radius: ${toRem(14)} ${toRem(14)} 0 0;
      }
    }

    .section-title {
      font-size: ${toRem(18)};
      @media ${baseVariables.mediaQuery.md} {
        font-size: ${toRem(24)};
      }
    }

    .section-wrapper {
      border-radius: 0;
      box-shadow: 0 ${toRem(2)} ${toRem(10)} 0 rgba(0, 0, 0, 0.07);
      background-color: ${baseVariables.color.base20};

      @media ${baseVariables.mediaQuery.lg} {
        border-radius: 0 0 ${toRem(14)} ${toRem(14)};
      }
    }

    .section-border {
      border-bottom: ${toRem(1)} solid ${baseVariables.color.neutral30};
    }
  }
`;
